<div class="form-group row">
    
    <label 
        for="vnet" 
        [ngStyle]="{'width': this.customWidth !== 0 ? this.customWidth + '%' : null}" 
        class="col-sm-{{this.lableWidth}} col-form-label">
        {{this.label}} <span style="color: red" *ngIf="showAsterisk"> *</span>
        <i
            *ngIf="this.showToolTip"
            class="fas fa-question-circle ms-1"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={{toolTipTitle}}
            style="cursor: pointer">
        </i>
    </label>
    
    <div class="col-sm-{{this.inputWidth}}">
        
        <div [ngClass]="{'input-group': this.showCopyBtn}">
            
            <input 
                type="text" 
                class="form-control form-control-sm px-{{paddingHorizontal}}" 
                id="vnet" [value]="this.value || ''" 
                [disabled]="this.disabled" 
                [readOnly]="this.readonly"
            />

            <button 
                *ngIf="this.showCopyBtn" 
                class="btn btn-outline-primary btn-sm"
                [style.cursor]="isCopying ? 'default' : 'pointer'"
                [ngClass]="{'btn-outline-success': isCopying, 'btn-outline-primary': !isCopying}" 
                type="button" 
                (click)="this.copyValue()">
                {{ isCopying ? 'Copied' : 'Copy' }}
            </button>
        
        </div>

    </div>

</div>